import type { SipPlansCategory } from '../../../../api/sipPlan.types'
import type { SipFund } from '../../../../api/common.types'
import { SipCategoryBucketKey, SIP_CATEGORY_BUCKET_TITLES, SipPlanMode, type SipActionFilter } from '../../../../api/types'
import { useSipPlanCategoryBucket } from '../../../usePlanCategoryBucketExpansion'
import { BucketAccordion } from '../../../../../lumpsum/plans-list/lumpsum-ui-components/BucketAccordion'
import { NoActionSipFundCard } from '../cards/NoActionSipFundCard'
import { getCategoryBucketItems } from '../../../../../utils/categoryBucketsUtils'
import { EventNames } from '../../../../../../../../types/misc.types'
import { trackEvent } from '../../../../../../../../utils/appBridge'
import { PlansScreen, PlansSipListEventIds } from '../../../../../analytics/plansEvents'

type NoActionSipBucketAccordionProps = {
  category: SipPlansCategory
  categoryId: string
  actionFilter: SipActionFilter
  isBorderTop?: boolean
}

export function NoActionSipBucketAccordion({
  category,
  categoryId,
  actionFilter,
  isBorderTop = false
}: NoActionSipBucketAccordionProps) {
  const noActionFunds = getCategoryBucketItems<SipFund>(category?.noActionFunds)
  const { bucketCompositeKey, isExpanded, toggle } = useSipPlanCategoryBucket({
    planMode: SipPlanMode.YOUR_PLAN,
    actionFilter,
    categoryId,
    bucketKey: SipCategoryBucketKey.noActionFunds
  })

  return (
    <BucketAccordion
      bucketCompositeKey={bucketCompositeKey}
      title={SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.noActionFunds]}
      count={noActionFunds.length}
      isExpanded={isExpanded}
      onToggle={() => {
        trackEvent({
          eventName: EventNames.UserClicked,
          payload: {
            ScreenName: PlansScreen.SipYourPlan,
            eventId: PlansSipListEventIds.BucketAccordion,
            buttonLabel: SIP_CATEGORY_BUCKET_TITLES[SipCategoryBucketKey.noActionFunds]
          }
        })
        toggle()
      }}
      isBorderTop={isBorderTop}
    >
      {noActionFunds.map((fund, fundIndex) => (
        <NoActionSipFundCard
          key={`${fund?.isin ?? 'fund'}-${fundIndex}`}
          fund={fund}
          showBottomDivider={fundIndex < noActionFunds.length - 1}
        />
      ))}
    </BucketAccordion>
  )
}
